import {
  View,
  StyleSheet,
  ScrollView,
  useWindowDimensions,
} from "react-native";
import SvaraModal from "./SvaraModal";
import {
  BtnSidebarClosePng,
  InvitedPlayerBackground,
  InvitesTitlePng,
  ModalTitle,
  ProfileImage,
  ProfileRegistration,
} from "../../../assets";
import InvitedPlayerCard from "./InviteModalComponents/InvitedPlayerCard";
import InviteNewPlayerCard from "./InviteModalComponents/InviteNewPlayer";

import { useDevice } from "../../../utils/hooks/useDevice";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../store";
import ModalReusable from "./ModalReusable";
import { useTranslation } from "react-i18next";

interface IProps {
  onClose: () => void;
}

function InvitesModal({ onClose }: IProps) {
  const { isDesktop } = useDevice();
  const dispatch = useDispatch();
  const loading = useSelector((s: RootState) => s.invites.loading);
  const { width } = useWindowDimensions();
  const isMobile = width < 600;
  const { t } = useTranslation();
  const raw = width * 0.6;
  const titleWidth = Math.max(240, raw);

  const invitedPlayers = [
    {
      id: 1,
      name: "default user",
      score: 23,
      chips: "2.222.222",
      avatarImage: ProfileImage,
    },
    {
      id: 2,
      name: "guest player",
      score: 11,
      chips: "1.000.000",
      avatarImage: ProfileImage,
    },
  ];
  return (
    <>
      <ModalReusable
        visible
        onClose={onClose}
        // backgroundImage={ProfileRegistration}
        titleImage={ModalTitle}
        title={t("T_SITE_MODAL_INVITATION_TITLE")}
        titleImageStyles={
          isMobile
            ? {
                width: titleWidth,
                minWidth: 230,
                // transform: [{ translateX: -titleWidth / 2 }],
              }
            : undefined
        }
        titleTextStyles={{ width: 230, height: 90, fontSize: 18, marginTop: 4 }}
        closeIcon={BtnSidebarClosePng}
        // nativeCloseButtonStyles={{
        //   width: 24,
        //   height: 24,
        //   top: 8,
        //   right: 8,
        // }}
      >
        <ScrollView
          contentContainerStyle={[
            styles.container,
            { minWidth: isDesktop ? 600 : 250, gap: isDesktop ? 10 : 6 },
          ]}
        >
          {/* {invitedPlayers.map((player) => (
            <InvitedPlayerCard
              key={player.id}
              name={player.name}
              score={player.score}
              chips={player.chips}
              avatarImage={player.avatarImage}
              backgroundImage={InvitedPlayerBackground}
            />
          ))} */}
          <View style={{ width: isDesktop ? "100%" : "90%" }}>
            <InviteNewPlayerCard />
          </View>
        </ScrollView>
      </ModalReusable>
    </>
  );
}

const styles = StyleSheet.create({
  container: {
    padding: 16,
  },
  photoButton: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    right: 80,
  },
  editButton: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    right: 145,
  },
  closeButton: {
    zIndex: 1,
    position: "absolute",
    width: 50,
    height: 50,
    top: -24,
    right: 17,
  },
  iconButtonImage: {
    width: 50,
    height: 50,
  },
  avatarWrapper: {
    position: "relative",
    display: "flex",
    alignItems: "center",
    width: 120,
    marginLeft: -10,
  },
  avatarBg: {
    width: 130,
    height: 100,
    position: "relative",
  },
  avatarImage: {
    width: 130,
    height: 76,
    position: "absolute",
    top: 13,
    left: -5,
  },
  scoreBadge: {
    width: 38,
    height: 38,
    position: "absolute",
    top: 30,
    left: 88,
  },
  scoreText: {
    width: 38,
    height: 38,
    position: "absolute",
    top: 36,
    left: 98,
    color: "#fff",
    fontSize: 18,
    fontWeight: "600",
  },
  statsHeader: {
    position: "relative",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginTop: 24,
    width: "52%",
    height: 20,
    marginLeft: "24%",
  },
  statsItem: {
    flexDirection: "row",
    alignItems: "center",
    width: 160,
  },
  statsIcon: {
    width: 34,
    height: 34,
  },
  statsText: {
    color: "white",
    fontSize: 18,
    marginLeft: 5,
    fontWeight: "bold",
  },
  nameWrapper: {
    position: "relative",
  },
  nameBg: {
    width: 224,
    height: 38,
  },
  nameText: {
    position: "absolute",
    top: 4,
    left: 60,
    flex: 1,
    color: "white",
    fontSize: 20,
    fontWeight: "500",
    marginLeft: 3,
    width: 120,
  },
  divider: {
    marginTop: 10,
    display: "flex",
    alignItems: "center",
    width: "100%",
  },
});

export default InvitesModal;
